<jafar-three-grid-spv
    [Header]="HeaderComponent"
    [MainGrid]="MainGridComponent"
    [TopGrid]="TopGridComponent"
    [BottomGrid]="BottomGridComponent"
></jafar-three-grid-spv>

